export function useSurfaceEditorStoreContextualPanel() {
  const contextualPanel = ref(null);

  function openContextualPanel(panel) {
    if (!panel?.id) return;

    contextualPanel.value = {
      id: panel.id,
      props: panel.props || {}
    };
  }

  function closeContextualPanel() {
    contextualPanel.value = null;
  }

  return {
    contextualPanel,
    openContextualPanel,
    closeContextualPanel
  };
}
